"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentUpdateActivity = exports.fieldsNameMap = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const KeyValueDisplay_1 = require("./KeyValueDisplay");
exports.fieldsNameMap = {
    containerNumbers: {
        label: 'activity-feed_shipment_update_container_numbers',
        singularLabel: 'activity-feed_shipment_update_container_number',
    },
    containerCustomerReferences: {
        label: 'activity-feed_shipment_update_container_customer_references',
        singularLabel: 'activity-feed_shipment_update_container_customer_reference',
    },
    sealNumbers: { label: 'Seal numbers', singularLabel: 'Seal number' },
    customerReference: { label: 'Customer reference' },
    additionalInformation: { label: 'activity-feed_shipment_update_additional_info' },
    incoTerms: { label: 'activity-feed_shipment_update_incoterm' },
    hblNumber: { label: 'activity-feed_shipment_update_house_bl' },
    hblType: {
        label: 'activity-feed_shipment_update_hbl_type_selection',
        translations: {
            original: 'shipment_details-shipping_instructions-hbl-type-original',
            express: 'shipment_details-shipping_instructions-hbl-type-express',
            seaWaybill: 'shipment_details-shipping_instructions-hbl-type-sea-waybill',
            seawaybill: 'shipment_details-shipping_instructions-hbl-type-sea-waybill',
            seawayBill: 'shipment_details-shipping_instructions-hbl-type-sea-waybill',
            draft: 'shipment_details-shipping_instructions-hbl-type-draft',
            telexRelease: 'shipment_details-shipping_instructions-hbl-type-telex-release',
            nonNegotiableCopy: 'shipment_details-shipping_instructions-hbl-type-non-negotiable-copy',
        },
    },
    pickupDetails: { label: 'activity-feed_shipment_update_pickup_address' },
    deliveryDetails: { label: 'activity-feed_shipment_update_delivery_address' },
    consigneeContact: { label: 'activity-feed_shipment_update_consignee_details' },
    shipperContact: { label: 'activity-feed_shipment_update_shipper_details' },
    containerTags: { label: 'activity-feed_shipment_update_container_tags' },
};
const ShipmentUpdateActivity = ({ activity: { changedFields } }) => {
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    const theme = (0, silhouette_core_1.useTheme)();
    const getContent = () => {
        const singleLineTextKeys = ['shipperContact', 'consigneeContact'];
        const changedFieldKeys = Object.keys(changedFields);
        const isSingleFieldShipperOrConsigneeChange = changedFieldKeys.length === 1 && changedFieldKeys[0] && singleLineTextKeys.indexOf(changedFieldKeys[0]) > -1;
        if (isSingleFieldShipperOrConsigneeChange) {
            const content = changedFieldKeys[0] ? translate(`${exports.fieldsNameMap[changedFieldKeys[0]].label}_updated`) : '';
            return (0, jsx_runtime_1.jsx)(silhouette_core_1.Typography, { color: "textSecondary", children: content });
        }
        return changedFieldKeys.map((key) => {
            if (key in exports.fieldsNameMap) {
                const fieldName = exports.fieldsNameMap[key];
                if (key === changedFields[key]) {
                    return ((0, jsx_runtime_1.jsx)(KeyValueDisplay_1.KeyValueDisplay, { label: translate(fieldName.label), value: translate('activity-feed_shipment_info_value_updated') }, translate(fieldName.label)));
                }
                const isSingularLabelApplicable = (changedFields[key]?.split(',').length ?? 0) <= 1 && fieldName.singularLabel;
                if (isSingularLabelApplicable) {
                    return ((0, jsx_runtime_1.jsx)(KeyValueDisplay_1.KeyValueDisplay, { label: translate(fieldName.singularLabel), value: changedFields[key] }, translate(fieldName.label)));
                }
                const value = fieldName.translations
                    ? translate(fieldName.translations[changedFields[key]])
                    : changedFields[key];
                return (0, jsx_runtime_1.jsx)(KeyValueDisplay_1.KeyValueDisplay, { label: translate(fieldName.label), value: value }, translate(fieldName.label));
            }
            console.error(`Translations missing for Shipment update changedField: "${key}"`);
            return (0, jsx_runtime_1.jsx)(KeyValueDisplay_1.KeyValueDisplay, { label: key, value: changedFields[key] }, key);
        });
    };
    return (0, jsx_runtime_1.jsx)(silhouette_core_1.Box, { color: theme.palette.menu.default, children: getContent() });
};
exports.ShipmentUpdateActivity = ShipmentUpdateActivity;
//# sourceMappingURL=ShipmentUpdateActivity.js.map